import axios from 'axios';

import { FacetCategory, IFacetCategory } from 'shared/models/facet';

import config from 'config/global';
import sortBy from 'lodash/sortBy';

class FacetService {
  private url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async find(categories: FacetCategory[], locale: string): Promise<IFacetCategory[]> {
    const query = categories.map((category) => `&categories=${category}`).join('');
    const response = await axios.get<IFacetCategory[]>(`${this.url}/facets/categories?lang=${locale}${query}`);

    response.data.forEach((facetCategory) =>
      facetCategory.facetGroups.forEach(
        (facetGroup) => (facetGroup.facets = sortBy(facetGroup.facets, [(facet) => facet.orderKey]))
      )
    );

    return response.data;
  }
}

export default new FacetService({
  url: config.facetsApiUrl,
});
